import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Navbar from "./components/admin/Navbar";
import PrivateRoute from "./components/PrivateRoute";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import AddProduct from "./pages/AddProduct";
import EditPhoto from "./pages/EditPhoto";
import AddMukhi from "./pages/AddMukhi";
import AutoMukhi from "./pages/AutoMukhi";
import WarrantyPublicPage from "./pages/WarrantyPublicPage";

function AdminLayout({ children }) {
  return (
    <>
      <Navbar />
      {children}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
      <Routes>
        {/* Public pages */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/warranty/:uniqueId" element={<WarrantyPublicPage />} />

        {/* Protected admin area */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <AdminLayout><Dashboard /></AdminLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/add"
          element={
            <PrivateRoute>
              <AdminLayout><AddProduct /></AdminLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/edit-photo"
          element={
            <PrivateRoute>
              <AdminLayout><EditPhoto /></AdminLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/add-mukhi"
          element={
            <PrivateRoute>
              <AdminLayout><AddMukhi /></AdminLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/auto-mukhi"
          element={
            <PrivateRoute>
              <AdminLayout><AutoMukhi /></AdminLayout>
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
